import { DentalMenu, Hpa, Unitas } from "../Components/Atoms/ProductCardLogos";

export const productCardLogos = {
    dentalMenu: DentalMenu,
    unitas: Unitas,
    hpa: Hpa,
};
